import validate from "/tmp/build_5b96a0a9/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/tmp/build_5b96a0a9/middleware/auth.global.js";
import lightbox_45transition_45global from "/tmp/build_5b96a0a9/middleware/lightbox-transition.global.js";
import manifest_45route_45rule from "/tmp/build_5b96a0a9/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  lightbox_45transition_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}